import { observer } from 'mobx-react'
import { useStores } from 'hooks/useStores'
import { Variant } from 'components/Button'
import { Button } from 'components/Button/styles'
import { useState } from 'react'
import { Uppercase } from 'styles/components'
import { StepType } from '../..'
import * as T from '../../styles'
import * as S from './styles'

type DataType = {
  company?: string
  number?: string
  country?: string
}

export const Step1 = observer(({number, currentStep, nextStep}: StepType) => {
  const { businessStore } = useStores();

  const [data, setData] = useState<DataType>({company: '', number: '', country: ''});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setData({...data, [e.target.name]: e.target.value});

  const disabledNext = !data.company || !data.number || !data.country;

  return (
    <S.Step isActive={number === currentStep}>
      <T.Title>Заполните форму о вашей компании</T.Title>
      <S.Form>
        <T.FormInput name='company' placeholder='Компания' value={data.company} onChange={handleChange}/>
        <S.Row>
          <T.FormInput name='number' placeholder='Количество сотрудников' value={data.number} onChange={handleChange}/>
          <T.FormInput name='country' placeholder='Страна' value={data.country} onChange={handleChange}/>
        </S.Row>
      </S.Form>
      <T.Buttons>
        <Button variant={Variant.Outline_Business} onClick={businessStore.toggleFeedback}><Uppercase>Вернутся на сайт</Uppercase></Button>
        <Button variant={Variant.Business} disabled={disabledNext} onClick={() => !!nextStep && nextStep(data)}>
          <Uppercase>К следующему шагу</Uppercase>
        </Button>
      </T.Buttons>
    </S.Step>
  )
})